import { request } from '@/shared/api';
function appendList(params, key, values) {
    if (!values?.length)
        return;
    for (const value of values) {
        params.append(key, value);
    }
}
export function buildFunnelHeatmapQuery(filters = {}) {
    const params = new URLSearchParams();
    if (filters.qualityMonths != null) {
        params.set('qualityMonths', String(filters.qualityMonths));
    }
    if (filters.quantityMonths != null) {
        params.set('quantityMonths', String(filters.quantityMonths));
    }
    if (filters.yMetric)
        params.set('yMetric', filters.yMetric);
    if (filters.comparePeriod)
        params.set('comparePeriod', filters.comparePeriod);
    if (filters.dataSource)
        params.set('dataSource', filters.dataSource);
    if (filters.projectId != null) {
        params.set('projectId', String(filters.projectId));
    }
    appendList(params, 'agencyNames', filters.agencyNames);
    if (filters.activeAgentsOnly)
        params.set('activeAgentsOnly', 'true');
    appendList(params, 'dealSources', filters.dealSources);
    if (filters.scope)
        params.set('scope', filters.scope);
    const qs = params.toString();
    return qs ? `?${qs}` : '';
}
export function fetchFunnelHeatmap(filters = {}) {
    return request(`/api/v1/reports/agent-funnel-engagement${buildFunnelHeatmapQuery(filters)}`);
}
export function fetchLastVisits(phone) {
    const params = new URLSearchParams({ phone });
    return request(`/api/v1/reports/agent-funnel-engagement/last-visits?${params.toString()}`);
}
